import { render } from "./pot-distribution.vue?vue&type=template&id=5b7e4ffc&scoped=true"
import script from "./pot-distribution.vue?vue&type=script&lang=js"
export * from "./pot-distribution.vue?vue&type=script&lang=js"

import "./pot-distribution.vue?vue&type=style&index=0&id=5b7e4ffc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7e4ffc"],['__file',"src/components/applications/pot/pot-distribution.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b7e4ffc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b7e4ffc', __exports__)) {
    api.reload('5b7e4ffc', __exports__)
  }
  
  module.hot.accept("./pot-distribution.vue?vue&type=template&id=5b7e4ffc&scoped=true", () => {
    api.rerender('5b7e4ffc', render)
  })

}


export default __exports__